import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Layout from './components/Layout'
import Login from './pages/Login'
import Register from './pages/Register'
import Dashboard from './pages/Dashboard'
import DataVisualization from './pages/DataVisualization'
import AssetProducts from './pages/AssetProducts'
import Analytics from './pages/Analytics'
import Settings from './pages/Settings'
import RoleManagement from './pages/RoleManagement'
import AccountManagement from './pages/AccountManagement'
import NotFound from './pages/NotFound'
import { useTheme } from './hooks/useTheme'

function App() {
  useTheme()
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="data" element={<DataVisualization />} />
          <Route path="assets" element={<AssetProducts />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="settings" element={<Settings />} />
          <Route path="roles" element={<RoleManagement />} />
          <Route path="accounts" element={<AccountManagement />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  )
}

export default App
